export const mediaAssetsQuery = `
query mediaAssetsQuery(
  $search: String,
  $folderId: [QueryArgument],
  $limit: Int,
  $offset: Int,
) {
  images: assets(
    volume: "images",
    folderId: $folderId,
    search: $search,
    includeSubfolders: true,
    limit: $limit,
    offset: $offset,
  ) {
    ... on images_Asset {
      id
      title
      listingLabel
      downloadImage: imagerTransform(transform: "assetDownload") {
        url
      }
      image: imagerTransform(transform: "assetCard") {
        url
      }
    }
  }
  total: assetCount(
    volume: "images",
    folderId: $folderId,
    search: $search,
    includeSubfolders: true,
  )
}
`;

// export const createInitialMediaCategoriesQuery = () => {
//   return `
//     query InitialMediaCategoriesQuery {
//       categories: categories(group: "imageTypes") {
//         ... on imageTypes_Category {
//           id
//           title
//           slug
//         }
//       }
//     }
//   `
// }
//
// export const createInitialMediaAssetsQuery = (categories: any[]) => {
//   const assetQueries = categories.map((category) => {
//     return `
//       ${category.slug}: assets(volume: "images", imageType: ${category.id}) {
//         ... on images_Asset {
//           id
//           title
//           image: imagerTransform(transform: "assetCard") {
//             url
//           }
//         }
//       }
//     `
//   })
//
//   return `
//     query InitialMediaAssetsQuery {
//       ${assetQueries.join(' ')}
//     }
//   `
// }
//
export const createMediaAssetsQuery = (search: string | null, imageType: null | string, filters: any) => {
  function formatFilters(filters: any) {
    const result = []
    for (let key in filters) {
      const filter = filters[key]
      if (filter !== null && Array.isArray(filter)) {
        result.push(filter);
      }
    }
    return result
  }
  const formattedFilters = formatFilters(filters);
  const filtersQuery = formattedFilters.length === 0 ? '' : `relatedToCategories: [${formattedFilters.map((filter: any) => `{ id: [${filter.map((item: number) => `"${item}"`).join(', ')}]}`)}]`

  return `
    query MediaAssetsQuery {
      images: assets(volume: "images", search: ${search ? `"${search}"` : null}, imageType: ${imageType}, relatedToEntries: {section: "products", ${filtersQuery} relatedViaField: "product"} ) {
        ... on images_Asset {
          id
          title
          image: imagerTransform(transform: "assetCard") {
            url
          }
        }
      }
    }
  `
}

// export const createMediaFiltersQuery = () => {
//   return `
//     query MediaFiltersQuery {
//       imageTypes: categories(group: "imageTypes") {
//         ... on imageTypes_Category {
//           id
//           title
//           showSecondaryFilters
//         }
//       }
//       productStyles: categories(group: "productStyles") {
//         ... on productStyles_Category {
//           id
//           title
//         }
//       }
//       productTypes: categories(group: "productTypes") {
//         ... on productTypes_Category {
//           id
//           title
//         }
//       }
//       models: categories(group: "models") {
//         ... on models_Category {
//           id
//           title
//         }
//       }
//       buildingTypes: categories(group: "buildingTypes") {
//         ... on buildingTypes_Category {
//           id
//           title
//         }
//       }
//     }
//   `
// }
